export default __webpack_public_path__ + "static/media/Roboto-Light.13d61ef8.ttf";